var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoNextQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1858_3798)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1858_3798)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1816 95.9657C84.4739 95.9657 104.977 75.4625 104.977 50.1704C104.977 24.8782 84.4739 4.375 59.1816 4.375C33.8896 4.375 13.3862 24.8782 13.3862 50.1704C13.3862 75.4625 33.8896 95.9657 59.1816 95.9657Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5336 89.622C81.129 89.622 98.6356 72.1153 98.6356 50.5199C98.6356 28.9246 81.129 11.418 59.5336 11.418C37.9383 11.418 20.4316 28.9246 20.4316 50.5199C20.4316 72.1153 37.9383 89.622 59.5336 89.622Z",
    fill: "#AEB8FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1858_3798)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5387 23.4188C34.2586 23.6601 25.0261 32.7928 24.6697 44.0696C24.4925 49.6719 26.4751 54.8087 29.8473 58.7115C31.3659 60.4688 31.7995 62.9178 31.0182 65.1051L29.6138 69.0371C29.1571 70.3161 30.6381 71.4093 31.7258 70.5958L36.7065 66.8708C38.1888 65.7623 40.0707 65.3501 41.8863 65.7078C43.7773 66.0804 45.7571 66.2033 47.7934 66.0351C58.5063 65.1484 66.9549 56.2888 67.34 45.5461C67.7811 33.2417 57.8043 23.1562 45.5387 23.4188Z",
    fill: "#5468FF"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9348 58.4766C42.5612 60.1977 40.764 61.3898 39.0431 61.0162C37.1958 60.6153 36.1385 58.8035 36.5122 57.0825C36.8948 55.3192 38.5992 54.1508 40.446 54.5518C42.1673 54.9253 43.3175 56.7134 42.9348 58.4766ZM43.8686 50.3275C43.5859 51.6289 42.0401 51.8649 41.0328 51.6462C39.6892 51.3546 38.6744 50.5628 38.9571 49.2615C40.0413 44.2659 41.0117 36.9601 42.0962 31.9644C42.4515 30.3273 43.9954 29.6953 45.7163 30.069C47.3535 30.4242 48.5384 31.6484 48.1829 33.2856C47.0985 38.2812 44.9528 45.3319 43.8686 50.3275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1858_3798)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9011 66.3742C88.0944 68.5542 87.5215 71.5006 88.4728 74.1659L89.1478 76.0572C88.2955 77.0451 87.3937 77.99 86.4472 78.8885L82.2529 75.7555C80.4829 74.4357 78.2454 73.9124 76.0748 74.3158C74.6751 74.5777 73.1077 74.8093 71.9698 74.8093C59.1141 74.8093 48.6938 64.389 48.6938 51.5331C48.6921 38.6901 59.1251 28.2569 71.9698 28.2569C84.824 28.2569 95.2458 38.6772 95.2458 51.5331C95.2462 57.1732 93.2386 62.3461 89.9011 66.3742Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4433 52.3824C74.2767 54.0761 74.2371 55.2583 74.2371 57.3069C74.2371 58.0556 73.843 58.922 71.9125 58.922C70.2977 58.922 69.746 58.3312 69.746 56.2825C69.746 52.8942 71.2431 51.279 72.3855 50.2941C73.6858 49.1912 75.8918 47.9696 75.8918 45.8424C75.8918 44.0301 74.316 43.1632 72.3461 43.1632C68.3278 43.1632 69.1942 46.1969 67.0669 46.1969C66.0032 46.1969 64.7031 45.4879 64.7031 43.951C64.7031 41.824 67.1458 38.6719 72.4644 38.6719C77.5073 38.6719 80.8559 41.4692 80.8559 45.1725C80.8559 48.8756 77.5073 51.5549 76.4433 52.3824ZM74.9858 64.6741C74.9858 66.2892 73.6459 67.7077 71.9522 67.7077C70.2582 67.7077 68.9579 66.2892 68.9579 64.6741C68.9579 63.0195 70.2977 61.6406 71.9522 61.6406C73.6067 61.6406 74.9858 63.0195 74.9858 64.6741Z",
    fill: "#00D9CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8955 42.4291C61.8955 41.4391 61.0929 40.6367 60.1028 40.6367C59.1128 40.6367 58.3105 41.4391 58.3105 42.4291V49.5994H51.1404C50.1492 49.5994 49.3477 50.4004 49.3477 51.3918C49.3477 52.3831 50.1492 53.1842 51.1404 53.1842H58.3105V60.3544C58.3105 61.3444 59.1128 62.1468 60.1028 62.1468C61.0929 62.1468 61.8955 61.3444 61.8955 60.3544V53.1842H69.0657C70.0565 53.1842 70.858 52.3831 70.858 51.3918C70.858 50.4004 70.0565 49.5994 69.0657 49.5994H61.8955V42.4291Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1858_3798",
    x: -0.000132561,
    y: -0.556818,
    width: 118.364,
    height: 118.363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.45455
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.69318
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.235294 0 0 0 0 0.501961 0 0 0 0 0.819608 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1858_3798"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1858_3798",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1858_3798",
    x: 15.4996,
    y: 19.1868,
    width: 61.0135,
    height: 65.7791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.93182
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.57955
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.239216 0 0 0 0 0.337255 0 0 0 0 0.941176 0 0 0 0.53 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1858_3798"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1858_3798",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1858_3798",
    x: 39.5348,
    y: 24.0305,
    width: 64.8699,
    height: 68.9471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.93182
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.57955
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.239216 0 0 0 0 0.337255 0 0 0 0 0.941176 0 0 0 0.53 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1858_3798"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1858_3798",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1858_3798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 123.295,
    fill: "white",
    transform: "translate(0 0.148438)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNextQuestion);
export default __webpack_public_path__ + "static/media/LogoNextQuestion.85b1364798848f7e83fe22416ea41172.svg";
export { ForwardRef as ReactComponent };